import React from "react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const TrainingPage = () => {
  const navigate = useNavigate();
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  return (
    <>
      <Card title="Training" className="card-professional">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginBottom: "20px",
            pointerEvents: isBlocked ? "none" : "auto",
            opacity: isBlocked ? 0.6 : 1,
            transition: "opacity 0.3s ease",
          }}
        >
          <div
            onClick={() => !isBlocked && navigate("/training-inflight", { state: { completed: false } })}
            className="circular-card newCard-main-3"
          >
            <h3>Training Inflight</h3>
          </div>

          <div
            onClick={() => !isBlocked && navigate("/training-list", { state: { completed: true } })}
            className="circular-card newCard-main-4"
          >
            <h3>Completed Training</h3>
          </div>
        </div>
      </Card>
    </>
  );
};
export default TrainingPage;
